<template>
  <div class="container">
    <img src="../../public/img/404.png" alt="">
  </div>
</template>

<script>
export default {
  name: "NotFound",
  data() {
    return {};
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {},
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 796px;
  min-width: 1100px;
}
.container img{
  width:750px;
  margin-top: -120px;
}
</style>